import { Injectable } from '@angular/core';
import { vectorTaggingToolsConfig } from '../../../../cross-team-shared/tools.config';
import { VectorTaggingShapeType } from '../../../../team-apis/otterdam/answers/shape-typings';
import { AbstractShapeTool2D } from '../shared/abstract-shape-tool-2d';
import {
  IncrementalShapeTool,
  IncrementalShapeToolHelper,
} from '../shared/tool-helpers/incremental-shape-tool-helper';

@Injectable()
export class LineTool
  extends AbstractShapeTool2D
  implements IncrementalShapeTool
{
  readonly name = vectorTaggingToolsConfig.Line.name;
  protected readonly shapeType: VectorTaggingShapeType = 'line';

  override async onActivate() {
    await super.onActivate();
    this.onEvent('container', 'mousedown', () => {
      this.registerHelper(
        new IncrementalShapeToolHelper(
          this,
          this.store('vectorOverlay'),
          this.injector,
        ),
      );
    });
  }
}
